// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TysiaListDialog from './data'

export default function TysiaListDialogFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TysiaListDialog">
      <TysiaListDialog {...props}>
        {children}
      </TysiaListDialog>
    </Flow>
  )
}
